/**
 * ClaudeCodeHarness — wraps `@anthropic-ai/claude-agent-sdk` behind the
 * generic `AgentHarness` interface.
 *
 * This is the ONLY module that should import from the SDK.
 */

import { query, tool, createSdkMcpServer } from "@anthropic-ai/claude-agent-sdk";
import type {
  AgentHarness,
  HarnessEvent,
  HarnessQueryOptions,
  HarnessToolDefinition,
  HarnessMcpServer,
  HarnessUserMessage,
} from "../types.js";

export class ClaudeCodeHarness implements AgentHarness {
  async *executeQuery(opts: {
    prompt: string | AsyncGenerator<HarnessUserMessage, void, unknown>;
    options: HarnessQueryOptions;
    resume?: string;
  }): AsyncGenerator<HarnessEvent, void> {
    const sdkEvents = query({
      prompt: opts.prompt as Parameters<typeof query>[0]["prompt"],
      options: {
        ...(opts.options as Parameters<typeof query>[0]["options"]),
        ...(opts.resume ? { resume: opts.resume } : {}),
        ...(opts.options.sessionId ? { sessionId: opts.options.sessionId } : {}),
        ...(opts.options.abortController ? { abortController: opts.options.abortController } : {}),
      },
    });

    for await (const event of sdkEvents) {
      yield event as unknown as HarnessEvent;
    }
  }

  createMcpServer(config: { name: string; tools: HarnessToolDefinition[] }): HarnessMcpServer {
    const sdkTools = config.tools.map((t) =>
      tool(
        t.name,
        t.description,
        t.schema,
        t.handler as Parameters<typeof tool>[3],
        t.annotations ? { annotations: t.annotations } : undefined,
      ),
    );
    return createSdkMcpServer({ name: config.name, tools: sdkTools });
  }
}
